import {translate} from "../../../../../helper/translate";
import {PREMIUM_TYPE_BASIC, PREMIUM_TYPE_PRO, PREMIUM_TYPE_STARTER, PREMIUM_TYPE_ULTIMATE} from "../const/premium_types.const";

class StylesManager {
    styles = [
        {
            name: translate('Photography'),
            conversion_style: 'photography',
            type: PREMIUM_TYPE_BASIC,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/photography/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/photography/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/photography/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/photography/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/photography/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/photography/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/photography/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/photography/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Graffiti'),
            conversion_style: 'graffiti',
            type: PREMIUM_TYPE_PRO,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/graffiti/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/graffiti/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/graffiti/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/graffiti/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/graffiti/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/graffiti/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/graffiti/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/graffiti/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Stock Photo'),
            conversion_style: 'stockphoto',
            type: PREMIUM_TYPE_PRO,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/stock_photo/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/stock_photo/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/stock_photo/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/stock_photo/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/stock_photo/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/stock_photo/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/stock_photo/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/stock_photo/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Print Art'),
            conversion_style: 'print_art',
            type: PREMIUM_TYPE_PRO,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/print_art/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/print_art/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/print_art/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/print_art/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/print_art/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/print_art/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/print_art/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/print_art/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Sticker'),
            conversion_style: 'sticker',
            type: PREMIUM_TYPE_PRO,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/sticker/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/sticker/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/sticker/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/sticker/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/sticker/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/sticker/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/sticker/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/sticker/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Realistic 2'),
            unrestricted: true,
            conversion_style: 'generic_photorealistic',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/realistic_2/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/realistic_2/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/realistic_2/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/realistic_2/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/realistic_2/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/realistic_2/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/realistic_2/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/realistic_2/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Realistic 3'),
            unrestricted: true,
            conversion_style: 'generic_photorealistic_2',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/realistic_3/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/realistic_3/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/realistic_3/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/realistic_3/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/realistic_3/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/realistic_3/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/realistic_3/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/realistic_3/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('All-Purpose'),
            unrestricted: true,
            conversion_style: 'generic_all_purpose_1',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/all_purpose_1/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/all_purpose_1/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/all_purpose_1/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/all_purpose_1/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/all_purpose_1/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/all_purpose_1/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/all_purpose_1/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/all_purpose_1/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('All-Purpose 2'),
            unrestricted: true,
            conversion_style: 'generic_all_purpose_2',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/all_purpose_2/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/all_purpose_2/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/all_purpose_2/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/all_purpose_2/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/all_purpose_2/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/all_purpose_2/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/all_purpose_2/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/all_purpose_2/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('All-Purpose 3'),
            unrestricted: true,
            conversion_style: 'generic_all_purpose_3',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/all_purpose_3/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/all_purpose_3/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/all_purpose_3/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/all_purpose_3/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/all_purpose_3/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/all_purpose_3/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/all_purpose_3/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/all_purpose_3/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('All-Purpose 4'),
            unrestricted: true,
            conversion_style: 'generic_all_purpose_4',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/all_purpose_4/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/all_purpose_4/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/all_purpose_4/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/all_purpose_4/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/all_purpose_4/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/all_purpose_4/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/all_purpose_4/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/all_purpose_4/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('All-Purpose 5'),
            unrestricted: true,
            conversion_style: 'generic_all_purpose_5',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/all_purpose_5/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/all_purpose_5/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/all_purpose_5/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/all_purpose_5/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/all_purpose_5/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/all_purpose_5/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/all_purpose_5/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/all_purpose_5/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('All-Purpose 6'),
            unrestricted: true,
            conversion_style: 'generic_all_purpose_6',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/all_purpose_6/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/all_purpose_6/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/all_purpose_6/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/all_purpose_6/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/all_purpose_6/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/all_purpose_6/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/all_purpose_6/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/all_purpose_6/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Cyberpunk'),
            conversion_style: 'cyberpunk',
            type: PREMIUM_TYPE_PRO,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/cyberpunk/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/cyberpunk/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/cyberpunk/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/cyberpunk/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/cyberpunk/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/cyberpunk/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/cyberpunk/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/cyberpunk/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Line Art Drawing'),
            conversion_style: 'line_art_drawing',
            type: PREMIUM_TYPE_PRO,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/line_art_drawing/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/line_art_drawing/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/line_art_drawing/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/line_art_drawing/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/line_art_drawing/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/line_art_drawing/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/line_art_drawing/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/line_art_drawing/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Logo'),
            conversion_style: 'logo',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/logo/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/logo/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/logo/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/logo/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/logo/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/logo/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/logo/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/logo/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Realistic'),
            conversion_style: 'photorealistic',
            type: PREMIUM_TYPE_BASIC,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/realistic/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/realistic/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/realistic/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/realistic/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/realistic/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/realistic/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/realistic/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/realistic/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Anime'),
            conversion_style: 'anime',
            type: PREMIUM_TYPE_BASIC,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/anime/1x.png`),
                '2x': require(`../assets/images/creator_studio_styles/anime/2x.png`),
                '3x': require(`../assets/images/creator_studio_styles/anime/3x.png`),
                '4x': require(`../assets/images/creator_studio_styles/anime/4x.png`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/anime/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/anime/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/anime/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/anime/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Explicit'),
            conversion_style: 'explicit',
            type: PREMIUM_TYPE_STARTER,
            nsfw: true,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/explicit/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/explicit/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/explicit/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/explicit/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/explicit/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/explicit/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/explicit/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/explicit/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Artistic'),
            conversion_style: 'artistic',
            type: PREMIUM_TYPE_BASIC,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/artistic/1x.png`),
                '2x': require(`../assets/images/creator_studio_styles/artistic/2x.png`),
                '3x': require(`../assets/images/creator_studio_styles/artistic/3x.png`),
                '4x': require(`../assets/images/creator_studio_styles/artistic/4x.png`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/artistic/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/artistic/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/artistic/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/artistic/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Cartoon'),
            conversion_style: 'cartoon',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/cartoon/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/cartoon/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/cartoon/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/cartoon/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/cartoon/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/cartoon/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/cartoon/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/cartoon/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Cartoon Realistic'),
            conversion_style: 'cartoon_realistic',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/cartoon_realistic/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/cartoon_realistic/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/cartoon_realistic/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/cartoon_realistic/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/cartoon_realistic/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/cartoon_realistic/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/cartoon_realistic/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/cartoon_realistic/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('3D'),
            conversion_style: '3d',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/3d/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/3d/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/3d/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/3d/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/3d/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/3d/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/3d/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/3d/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Explicit 3D'),
            conversion_style: 'explicit_3d',
            type: PREMIUM_TYPE_STARTER,
            nsfw: true,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/explicit_3d/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/explicit_3d/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/explicit_3d/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/explicit_3d/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/explicit_3d/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/explicit_3d/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/explicit_3d/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/explicit_3d/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Anime 2'),
            conversion_style: 'anime_2',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/anime_2/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/anime_2/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/anime_2/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/anime_2/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/anime_2/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/anime_2/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/anime_2/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/anime_2/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Anime 3'),
            conversion_style: 'anime_3',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/anime_3/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/anime_3/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/anime_3/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/anime_3/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/anime_3/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/anime_3/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/anime_3/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/anime_3/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Anime 4'),
            conversion_style: 'anime_4',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/anime_4/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/anime_4/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/anime_4/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/anime_4/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/anime_4/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/anime_4/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/anime_4/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/anime_4/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Drawing'),
            conversion_style: 'drawing',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/drawing/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/drawing/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/drawing/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/drawing/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/drawing/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/drawing/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/drawing/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/drawing/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Sketch Drawing'),
            conversion_style: 'sketch_drawing',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/sketch_drawing/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/sketch_drawing/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/sketch_drawing/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/sketch_drawing/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/sketch_drawing/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/sketch_drawing/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/sketch_drawing/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/sketch_drawing/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Line Art'),
            conversion_style: 'line_art',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/line_art/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/line_art/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/line_art/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/line_art/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/line_art/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/line_art/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/line_art/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/line_art/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Catalogue'),
            conversion_style: 'catalogue',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/catalogue/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/catalogue/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/catalogue/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/catalogue/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/catalogue/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/catalogue/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/catalogue/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/catalogue/sidebar@4x.png`),
                },
            },
        },
        {
            name: translate('Pixelart'),
            conversion_style: 'pixel',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/pixel/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/pixel/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/pixel/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/pixel/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/pixel/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/pixel/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/pixel/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/pixel/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Pixelart 2'),
            conversion_style: 'pixel_2',
            type: PREMIUM_TYPE_STARTER,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/pixel_2/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/pixel_2/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/pixel_2/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/pixel_2/4x.jpg`),
                sidebar: {
                    '1x': require(`../assets/images/creator_studio_styles/pixel_2/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/pixel_2/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/pixel_2/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/pixel_2/sidebar@4x.png`),
                },
            },
        },
    ];

    constructor() {
    }

    getStylesByType(type) {
        return this.styles.filter(obj => {
            return obj.type === type
        })
    }

    getStylesByTypeFilteredForEducation(type) {
        return this.styles.filter(obj => {
            return obj.type === type && obj.nsfw !== true
        })
    }

    getStyleByName(name) {
        return this.styles.find(style => style.conversion_style === name);
    }
}

export default new StylesManager()
